import {Observable} from 'rxjs';
import {RestQueryParams} from '../base/queryParams';
import {palipaliAPI} from '../provider/palipaliAPI';
import {IRequestUserSetNewPasswordInput} from '../../model/user';

export function createRequestResetPasswordAPI(payload: IRequestUserSetNewPasswordInput): Observable<any> {
    return palipaliAPI.post(`api/users/request_set_new_password`, payload, new RestQueryParams());
}
